import React from "react"
import ReactSelect from "react-select"

import "./styles.css"

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    width: state.selectProps.width,
    color: state.isSelected ? state.selectProps.color : state.selectProps.color,
    background: state.isSelected ? "#F7F7F7" : "#fff",
    padding: 20,
  }),
  container: (provided, state) => ({
    ...provided,
    zIndex: "20",
    width: state.selectProps.width,
  }),
  control: (provided, { isFocused, selectProps: { width, color } }) => ({
    ...provided,
    width: width,
    border: `1px solid ${color}`,
    borderRadius: 40,
    boxShadow: "none",
    "&:hover": {
      borderColor: color,
    },
  }),
  indicatorSeparator: () => ({
    dipslay: "none",
  }),
  dropdownIndicator: (provided, { selectProps: { color } }) => ({
    ...provided,
    color: color,
    "&:hover": {
      color: color,
    },
  }),
  singleValue: (provided, { isDisabled, selectProps: { color } }) => {
    const opacity = isDisabled ? 0.5 : 1
    const transition = "opacity 300ms"

    return { ...provided, opacity, transition, color }
  },
}

const Select = ({
  options,
  handleChange,
  selectedOption = "",
  width = "100%",
  color = "#333",
}) => {
  return (
    <ReactSelect
      styles={customStyles}
      color={color}
      width={width}
      value={(function () {
        if (!selectedOption) return null

        return {
          value: selectedOption,
          label:
            options.length && selectedOption
              ? options.filter((option) => option.value === selectedOption)[0]
                  .label
              : "",
        }
      })()}
      onChange={handleChange}
      options={options}
      isSearchable={false}
    />
  )
}

export default Select
